module.exports = __webpack_public_path__ + "img/thumb-mug.23a7f33c.png";